import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobsRoutingModule } from './jobs-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbHighlight, NgbModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../shared/shared.module';
import { JobsComponent } from 'src/app/components/jobs/jobs.component';
import { DataImportService } from 'src/app/services/system-config/data-import/dataimport';
import { JOBQueueStatusRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/JOBQueueStatusRenderer';
import { JobsValidationComponent } from 'src/app/components/jobs/jobs-validation/jobs-validation.component';
import { JobsErrorComponent } from 'src/app/components/jobs/jobs-error/jobs-error.component';
import { ImportErrorComponent } from 'src/app/components/jobs/import-error/importerror.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';


@NgModule({
  declarations: [
    JobsComponent,
    JOBQueueStatusRenderer,
    JobsValidationComponent,
    JobsErrorComponent,
    ImportErrorComponent
  ],
  imports: [
    CommonModule,
    JobsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbHighlight,
    NgbNavModule,
    NgbDropdownModule,
    NgbTypeaheadModule,
    NgbPaginationModule,
    NgSelectModule,
    NgMultiSelectDropDownModule,
    NgbModule,
    AgGridModule
  ],
  exports: [
    JobsComponent,
    JOBQueueStatusRenderer,
    JobsValidationComponent,
    JobsErrorComponent,
    ImportErrorComponent
  ],
  providers: [DataImportService]
})
export class JobsModule { }
